// @ts-nocheck

import { type StateType } from '../../../states';
import { SportId, type SportState } from '../../../states/entities/sports';
import { type EntitiesSports } from '../../../states/entities/sports';
import { type CategoryId } from '../../../types/categories';
import { type Selector } from '../../../types/selectors';
import { getSportIdFromProps } from '../../_propsGetters_';
import { selectEntitiesState } from '../entitiesPrimary.selector';

const emptyObject = {};

export const selectEntitiesSports: Selector<EntitiesSports> = (state: StateType) =>
  selectEntitiesState(state)?.sports ?? emptyObject;

export type EntitiesSportsSelectorProps = {
  sportId?: number;
};

export const selectEntitiesSportsEntity: Selector<SportState | undefined> = (
  state: StateType,
  props: EntitiesSportsSelectorProps = {},
) => {
  const sportId = getSportIdFromProps(state, { sportId: props.sportId as SportId });

  if (sportId) {
    return selectEntitiesSports(state)[sportId];
  }
};

export const selectEntitiesSportsEntitySportId: Selector<SportId | undefined> = (
  state: StateType,
  props: EntitiesSportsSelectorProps = {},
) => selectEntitiesSportsEntity(state, props)?.sportId;

export const selectEntitiesSportsEntitySportName: Selector<string | undefined> = (
  state: StateType,
  props: EntitiesSportsSelectorProps = {},
) => selectEntitiesSportsEntity(state, props)?.sportName;

export const selectEntitiesSportsEntityCategories: Selector<Array<CategoryId> | undefined> = (
  state: StateType,
  props: EntitiesSportsSelectorProps = {},
) => selectEntitiesSportsEntity(state, props)?.categories;

export const selectEntitiesSportsEntityMainMatchCount: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesSportsSelectorProps = {},
) => selectEntitiesSportsEntity(state, props)?.mainMatchCount;

export const selectEntitiesSportsEntityLiveMatchCount: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesSportsSelectorProps = {},
) => selectEntitiesSportsEntity(state, props)?.liveMatchCount;

export const selectEntitiesSportsEntityTvMatchCount: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesSportsSelectorProps = {},
) => selectEntitiesSportsEntity(state, props)?.tvMatchCount;

export const selectEntitiesSportsEntityFilters: Selector<Array<number> | undefined> = (
  state: StateType,
  props: EntitiesSportsSelectorProps = {},
) => selectEntitiesSportsEntity(state, props)?.filters;

export const selectEntitiesSportsEntityWarning: Selector<string | undefined> = (
  state: StateType,
  props: EntitiesSportsSelectorProps = {},
) => selectEntitiesSportsEntity(state, props)?.warning;

export const selectEntitiesSportsEntityPrematchPromo: Selector<string | undefined> = (
  state: StateType,
  props: EntitiesSportsSelectorProps = {},
) => selectEntitiesSportsEntity(state, props)?.prematchPromo;

export const selectEntitiesSportsEntityLivePromo: Selector<string | undefined> = (
  state: StateType,
  props: EntitiesSportsSelectorProps = {},
) => selectEntitiesSportsEntity(state, props)?.livePromo;
